module.exports = __webpack_public_path__ + "static/tt-desktop-options-306279ce7e11b3083fb745811282bb47.png";